package features.members.domain

data class Member(
    val id: String,
    val name: String,
    val email: String,
    val role: String,
    val joinDate: String? = null,
    val quota: Int = 12
) {
    fun canBeEditedBy(currentUserRole: String): Boolean {
        return when (currentUserRole) {
            "owner" -> true
            "admin" -> role != "owner"
            else -> false
        }
    }
    
    fun canBeDeletedBy(currentUserRole: String): Boolean {
        return when (currentUserRole) {
            "owner" -> true
            "admin" -> role == "member"
            else -> false
        }
    }
}
